import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  id: "item-details",
  class: "col-xs-12 col-sm-7"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "alternate-name"
}
const _hoisted_5 = { class: "font-size-lg text-primary" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column align-items-end flex-grow-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "d-flex flex-column align-items-end flex-grow-1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "pt-3"
}
const _hoisted_12 = {
  key: 0,
  class: "pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WCImageGallery = _resolveComponent("WCImageGallery")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WCProductPricing = _resolveComponent("WCProductPricing")!
  const _component_WCBasicAddToCartButton = _resolveComponent("WCBasicAddToCartButton")!
  const _component_WCAddToListButton = _resolveComponent("WCAddToListButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_WCProductDetails = _resolveComponent("WCProductDetails")!
  const _component_WCTab = _resolveComponent("WCTab")!
  const _component_WCCustomContent = _resolveComponent("WCCustomContent")!
  const _component_WCNutritionFacts = _resolveComponent("WCNutritionFacts")!
  const _component_WCCouponCard = _resolveComponent("WCCouponCard")!
  const _component_WCProductCardGroup = _resolveComponent("WCProductCardGroup")!
  const _component_WCTabNav = _resolveComponent("WCTabNav")!
  const _component_WCAlternateItems = _resolveComponent("WCAlternateItems")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_WCImageGallery, {
            class: "col-xs-12 col-sm-5",
            item: _ctx.item
          }, null, 8, ["item"]),
          _cache[16] || (_cache[16] = _createTextVNode()),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", {
              class: "name font-weight-bold",
              id: _ctx.item.id
            }, [
              _createTextVNode(_toDisplayString(_ctx.item.name), 1),
              (_ctx.item.alternateName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "\n            - " + _toDisplayString(_ctx.item.alternateName), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3),
            _cache[12] || (_cache[12] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.brand), 1),
            _cache[13] || (_cache[13] = _createTextVNode()),
            (_ctx.shouldHideItemPrices)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "btn btn-primary btn-block w-50 mb-3 wc-atc-btn wc-atc-btn--basic",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('signInToShop')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_WCProductPricing, {
                    item: _ctx.item,
                    class: "my-3 font-size-xl text-right"
                  }, null, 8, ["item"]),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_8, [
                    (!_ctx.isCustomerModeScan)
                      ? (_openBlock(), _createBlock(_component_WCBasicAddToCartButton, {
                          key: 0,
                          item: _ctx.item,
                          class: "btn-block w-50 mb-3",
                          describedBy: _ctx.item.id,
                          orderType: _ctx.activeOrderType
                        }, null, 8, ["item", "describedBy", "orderType"]))
                      : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (!_ctx.isItemListOnly(_ctx.item))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (
                  (!_ctx.item.hasModifiers && !_ctx.item.hasLinkedItems) ||
                    (!_ctx.item.hasModifiers && !_ctx.item.hasLinkedItems && !_ctx.$configuration.cartEnabled)
                )
                            ? (_openBlock(), _createBlock(_component_WCAddToListButton, {
                                key: 0,
                                item: _ctx.item
                              }, null, 8, ["item"]))
                            : (
                  _ctx.item.hasModifiers ||
                    _ctx.item.hasLinkedItems ||
                    (_ctx.item.hasModifiers && !_ctx.$configuration.cartEnabled) ||
                    (_ctx.item.hasLinkedItems && !_ctx.$configuration.cartEnabled)
                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("button", {
                                    class: "btn btn-link underline-link-from-center p-0",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.customizeItemToAddToList())),
                                    ref: "customizeBtnRef"
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('customizeAndAddToList')), 1),
                                    _createVNode(_component_font_awesome_icon, {
                                      class: "ml-2",
                                      icon: "list-check"
                                    })
                                  ], 512)
                                ]))
                              : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])),
            _cache[14] || (_cache[14] = _createTextVNode()),
            _createVNode(_component_WCTabNav, {
              ariaLabel: _ctx.$t('productInfo'),
              class: "tabs-panel font-size-sm",
              onSelected: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab = $event)),
              tabs: _ctx.tabs
            }, {
              default: _withCtx(() => [
                _createVNode(_component_WCTab, {
                  title: _ctx.$t('details'),
                  selected: _ctx.$t('details') === _ctx.selectedTab
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_WCProductDetails, {
                      item: _ctx.item,
                      custom: _ctx.detailsCustomContent
                    }, null, 8, ["item", "custom"])
                  ]),
                  _: 1
                }, 8, ["title", "selected"]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customSourcesMinusDuplicates, (cs) => {
                  return (_openBlock(), _createBlock(_component_WCTab, {
                    key: cs.id,
                    title: cs.label,
                    selected: cs.label === _ctx.selectedTab
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_WCCustomContent, {
                        content: cs.content
                      }, null, 8, ["content"])
                    ]),
                    _: 2
                  }, 1032, ["title", "selected"]))
                }), 128)),
                _cache[9] || (_cache[9] = _createTextVNode()),
                (
              (_ctx.item.nutrition && _ctx.item.nutrition.length > 0) ||
                _ctx.item.ingredients ||
                _ctx.nutritionCustomContent
            )
                  ? (_openBlock(), _createBlock(_component_WCTab, {
                      key: 0,
                      title: _ctx.$t('nutrition'),
                      selected: _ctx.$t('nutrition') === _ctx.selectedTab
                    }, {
                      default: _withCtx(() => [
                        (_ctx.item.nutrition && _ctx.item.nutrition.length > 0)
                          ? (_openBlock(), _createBlock(_component_WCNutritionFacts, {
                              key: 0,
                              item: _ctx.item
                            }, null, 8, ["item"]))
                          : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (_ctx.item.ingredients)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t('ingredients')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.item.ingredients), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        (_ctx.nutritionCustomContent)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_WCCustomContent, {
                                content: _ctx.nutritionCustomContent.content
                              }, null, 8, ["content"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["title", "selected"]))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createVNode(_component_WCTab, {
                  title: _ctx.$t('disclaimer'),
                  selected: _ctx.$t('disclaimer') === _ctx.selectedTab
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t('disclaimer')) + ": ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('disclaimerText')) + " " + _toDisplayString(_ctx.$configuration.store.name) + " " + _toDisplayString(_ctx.$t('assumesNoLiability')), 1)
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    (_ctx.disclaimerCustomContent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_WCCustomContent, {
                            content: _ctx.disclaimerCustomContent.content
                          }, null, 8, ["content"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title", "selected"]),
                _cache[11] || (_cache[11] = _createTextVNode()),
                (_ctx.$configuration.allowCouponClipping && _ctx.displayableCoupons(_ctx.item))
                  ? (_openBlock(), _createBlock(_component_WCTab, {
                      key: 1,
                      title: _ctx.$t('digitalCoupons'),
                      selected: _ctx.$t('digitalCoupons') === _ctx.selectedTab
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t('digitalCoupons')), 1)
                        ]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        _createVNode(_component_WCProductCardGroup, {
                          role: "list",
                          class: "wc-coupon-detail-product-card-group"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayableCoupons(_ctx.item), (coupon) => {
                              return (_openBlock(), _createBlock(_component_WCCouponCard, {
                                key: coupon.id,
                                coupon: coupon,
                                role: "listitem"
                              }, null, 8, ["coupon"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["title", "selected"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["ariaLabel", "tabs"]),
            _cache[15] || (_cache[15] = _createTextVNode()),
            _createVNode(_component_WCAlternateItems, {
              class: "pt-3",
              item: _ctx.item,
              showAddToCartButton: !_ctx.isCustomerModeScan
            }, null, 8, ["item", "showAddToCartButton"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}